import React from 'react'

type HighlightProps = {
  hit: any
  attribute: string
  className?: string
  fallback?: string
}

/**
 * Composant pour afficher le texte avec surlignage des termes de recherche
 * Utilise _highlightResult (cf. lib/search/highlight)
 */
const Highlight: React.FC<HighlightProps> = ({ hit, attribute, className, fallback }) => {
  const highlightResult = hit?._highlightResult?.[attribute]

  if (!highlightResult) {
    const value = hit?.[attribute] ?? fallback ?? ''
    return <span className={className}>{value}</span>
  }

  const highlightedValue = highlightResult.value ?? hit?.[attribute] ?? fallback ?? ''

  return (
    <span
      className={className}
      dangerouslySetInnerHTML={{ __html: highlightedValue }}
    />
  )
}

export default Highlight
